// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(/ssr/css/api_intro.css);"]);
// Module
exports.push([module.id, "\n.container[data-v-595d9f0e] {\n  width: 100%;\n  min-height: 100vh;\n  background: #ffffff;\n}\n.main[data-v-595d9f0e] {\n  width: 100%;\n}\n.code-sample[data-v-595d9f0e] {\n  width: 100%;\n  max-width: 800px;\n  margin: 30px auto;\n  background: #1e1e1e;\n  border-radius: 12px;\n  padding: 20px;\n  overflow-x: auto;\n}\n.code-sample code[data-v-595d9f0e] {\n  color: #fff;\n  font-family: 'Fira Code', monospace;\n}\n", ""]);
// Exports
module.exports = exports;
